(() => {
  const dialog = document.querySelector('#sb-support-dialog');
  const frame = document.querySelector('[data-sb-chat-frame]');
  const trigger = document.querySelector('[data-sb-chat-open]');
  if (!dialog || !frame || !trigger || dialog.dataset.initialized === 'true') return;
  dialog.dataset.initialized = 'true';
  const status = dialog.querySelector('[data-sb-chat-status]');
  const loading = dialog.querySelector('[data-sb-chat-loading]');
  const error = dialog.querySelector('[data-sb-chat-error]');
  const origin = 'https://dashboard.starsbooster.io';
  let previousFocus = null;
  let ready = false;
  let timer = null;
  const notify = () => frame.contentWindow?.postMessage({ type: 'sb-support-visibility', open: dialog.open }, origin);
  const close = () => { dialog.close(); trigger.setAttribute('aria-expanded', 'false'); notify(); previousFocus?.focus(); };
  const fail = () => {
    clearTimeout(timer);
    if (ready) return;
    if (status) status.hidden = false;
    if (loading) loading.hidden = true;
    if (error) error.hidden = false;
  };
  const connect = () => {
    ready = false;
    clearTimeout(timer);
    if (status) status.hidden = false;
    if (loading) loading.hidden = false;
    if (error) error.hidden = true;
    frame.src = `${origin}/support/chat`;
    timer = setTimeout(fail, 20_000);
  };
  const open = (source) => {
    if (dialog.open) { frame.focus(); return; }
    previousFocus = source;
    if (!frame.hasAttribute('src')) connect();
    dialog.show(); trigger.setAttribute('aria-expanded', 'true'); notify();
    if (ready) frame.focus();
    const badge = trigger.querySelector('[data-sb-chat-badge]'); if (badge) badge.hidden = true;
  };
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const direct = event.target.closest('[data-sb-chat-open], [data-sb-live-chat-open]');
    const link = event.target.closest('a[href]');
    let matched = Boolean(direct);
    if (link) {
      const url = new URL(link.href, location.href);
      matched = url.origin === location.origin && url.pathname.endsWith('/pages/contact-us') && url.hash === '#live-chat';
    }
    if (matched) { event.preventDefault(); (direct || link)?.closest('details')?.removeAttribute('open'); open(direct || link); }
    if (event.target.closest('[data-sb-chat-close]')) close();
    if (event.target.closest('[data-sb-chat-retry]')) connect();
  });
  dialog.addEventListener('cancel', event => { event.preventDefault(); close(); });
  dialog.addEventListener('keydown', event => { if (event.key === 'Escape') { event.preventDefault(); close(); } });
  frame.addEventListener('load', notify);
  frame.addEventListener('error', fail);
  window.addEventListener('hashchange', () => { if (location.hash === '#live-chat') open(trigger); });
  window.addEventListener('message', event => {
    if (event.origin !== origin || event.source !== frame.contentWindow) return;
    if (event.data?.type === 'sb-support-ready') {
      ready = true; clearTimeout(timer);
      if (status) status.hidden = true;
      notify();
      if (dialog.open) frame.focus();
      return;
    }
    if (event.data?.type === 'sb-support-close') { if (dialog.open) close(); return; }
    if (event.data?.type !== 'sb-support-unread' || !Number.isSafeInteger(event.data.unread) || event.data.unread < 0) return;
    const badge = trigger.querySelector('[data-sb-chat-badge]');
    if (badge) { badge.textContent = event.data.unread > 99 ? '99+' : String(event.data.unread); badge.hidden = dialog.open || !event.data.unread; }
  });
  if (location.hash === '#live-chat') open(trigger);
})();
